import React from "react";
import dsPdfs from "../data/pdf.json";
import dsLinks from "../data/links.json";
import assets from "../data/config/config.json";

var pdfs = dsPdfs[0],
  links = dsLinks[0];

const audio = assets.audio;
const img = assets.img.desarrolloProfesional;
const imgGeneral = assets.img.general;

const reproducirSonido = () => {
  console.log("Audio");

  var tmpAudio = document.getElementById("desarrollo");
  tmpAudio.currentTime = 0;
  tmpAudio.play();
};

const DesarrolloProf = (props) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-5 col-derecha">
          <img
            tabIndex="1"
            role="banner"
            className="titulos img-fluid"
            src={img + "titulo_desarrollo.png"}
            alt="Banner de Desarrollo Profesional"
          />
          <img
            id="imgFondoDescripcion"
            onClick={reproducirSonido}
            className="descripciones4 img-fluid"
            src={imgGeneral + "caja_descripcion.png"}
            alt="Descripción de la sección de Desarrollo Profesional"
          />
          <div
            tabIndex="2"
            onClick={reproducirSonido}
            onKeyPress={reproducirSonido}
            id="textoDescripcion"
            className="texto_descripciones text-justify pr-3"
          >
            <h2 className="desc">Descripción:</h2> {props.infoCategory}
          </div>
          <a
            tabIndex="2"
            href={links.IDP}
            target="_blank"
            rel="noopener noreferrer"
          >            
            <img
              id="material_adicional"
              className="img-fluid hvr-wobble-bottom"
              src={img + "enlace_desarrollo.png"}
              alt="Enlace a página del Instituto de Desarrollo Profesional"
            />
          </a>
        </div>

        <div className="col-7">
          <div className="botones_salir col-12">
            <img
              tabIndex="3"
              data-tar="Home"
              onClick={props.changePage}
              onKeyPress={props.changePage}
              className="derecha btn img-fluid hvr-pop"
              src={imgGeneral + "btn_salir.png"}
              alt="regresar a portada"
            />
          </div>

          <div className="row mt-5 pt-5">
            <div className="col-6 text-right">
              <a
                href="https://capacitacion.mep.go.cr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  id="cursos"
                  onMouseOver={props.onMouseOver}
                  data-infosource={0}
                  data-content={pdfs.Tacaco}
                  data-typecontent="pdf"
                  src="./assets/img/desa-prof/ch_btn_cursosvirtuales.png"
                  alt="Cursos virtuales"
                />
              </a>
            </div>
            <div className="col-6">
              <img
                role="button"
                id="recursos"
                data-content={pdfs.Tacaco}
                data-typecontent="pdf"
                data-infosource={0}
                onMouseOver={props.onMouseOver}
                onMouseOut={props.onMouseOut}
                onClick={props.handlerOpenCatalogWeb}
                onKeyPress={props.handlerOpenCatalogWeb}
                alt="Recursos digitales para educadores"
                src="./assets/img/desa-prof/ch_btn_recursosdigitales.png"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6 text-right">
              <a
                href="https://www.youtube.com/channel/UCt2Qlh-gT3JsWRJ3el_BclQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  id="webinarios"
                  data-content={pdfs.Tacaco}
                  data-typecontent="pdf"
                  data-infosource={0}
                  onMouseOver={props.onMouseOver}
                  src="./assets/img/desa-prof/ch_btn_webinarios.png"
                  alt="Webinarios"
                />
              </a>
            </div>
            <div className="col-6">
              <img
                role="button"
                src="./assets/img/desa-prof/ch_btn_servicios.png"
                id="servicios"
                data-content={pdfs.Tacaco}
                data-typecontent="pdf"
                data-infosource={0}
                data-tar="Construccion"
                data-origen="DesarrolloProf"
                onMouseOver={props.onMouseOver}
                onMouseOut={props.onMouseOut}
                onClick={props.changePage}
                onKeyPress={props.changePage}
                alt="Servicios docentes"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6 text-right">
              <a
                href="http://videoteca.mep.go.cr/userportal/#/home/main"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  id="videoteca"
                  data-content={pdfs.Tacaco}
                  data-typecontent="pdf"
                  data-infosource={0}
                  onMouseOver={props.onMouseOver}
                  onMouseOut={props.onMouseOut}
                  src="./assets/img/desa-prof/ch_btn_videoteca.png"
                  alt="Videoteca"
                />
              </a>
            </div>
            <div className="col-6">
              <img
                role="button"
                src="./assets/img/desa-prof/ch_btn_otrasofertas.png"
                tabIndex="2"
                className="botones-portada img-fluid"
                id="ficha"
                data-content={pdfs.Tacaco}
                data-typecontent="pdf"
                data-infosource={0}
                onMouseOver={props.onMouseOver}
                onMouseOut={props.onMouseOut}
                onClick={props.handlerOpenCatalog}
                onKeyPress={props.handlerOpenCatalog}
                alt="Otras ofertas de formación"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6 text-right">
              <a
                href="https://idp.mep.go.cr/vocacion-docente"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="./assets/img/desa-prof/ch_btn_programa_radial.png"
                  id="radial"
                  data-content={pdfs.Tacaco}
                  data-typecontent="pdf"
                  data-infosource={0}
                  onMouseOver={props.onMouseOver}
                  onMouseOut={props.onMouseOut}
                  alt="Programa radial Vocación docente"
                />
              </a>
            </div>

            <div className="col-6">
            <a
                href="https://calendario-idp.mep.go.cr/2023/app/index.html"
                target="_blank"
                rel="noopener noreferrer"
              >
              <img
                role="button"
                src="./assets/img/desa-prof/ch_btn_calendario.png"
                id="calendario"
                data-content={pdfs.Tacaco}
                data-typecontent="pdf"
                data-infosource={0}
                // data-tar="Construccion"
                // data-origen="DesarrolloProf"
                // onClick={props.changePage}
                // onKeyPress={props.changePage}
                onMouseOver={props.onMouseOver}
                onMouseOut={props.onMouseOut}
                alt="Calendario formación docente"
              />
              </a>
            </div>
          </div>

          
        </div>
      </div>
      <br />

      <audio
        src={audio + "desarrollo_profesional.mp3"}
        id="desarrollo"
        preload="true"
      ></audio>
    </React.Fragment>
  );
};

export default DesarrolloProf;
